import axios from 'axios';
import {
  BlockstreamAddressStatsDto,
  blockstreamAddressStatsFromApiResponse,
} from '../models/BlockstreamAddressStatsDto';

const BLOCKSTREAM_API_BASE_URL = 'https://blockstream.info/api';

export class BlockstreamRepository {
  async getBlockstreamAddressStats(address: string): Promise<BlockstreamAddressStatsDto> {
    const response = await axios.get(
      `${BLOCKSTREAM_API_BASE_URL}/address/${encodeURIComponent(address)}`,
      { timeout: 10000 },
    );
    return blockstreamAddressStatsFromApiResponse(response.data);
  }
}

export const blockstreamRepository = new BlockstreamRepository();
